import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useAppSelector } from "../../hooks/redux";
import Loader from "src/components/loader/loader";
const SelectedExpiryOc = () => {
    const selectedExpiryData = useAppSelector((state) => {
        return state.modals.selectedExpiry;
    });
    const getAddToBasketModal = useAppSelector((state) => {
        return state.modals.addToBasketPayload;
    });
    const SelectedExpiry = React.lazy(() => import("src/pages/dashboard/fullscreen-oc-view/selectedExpiry"));
    return (_jsx(_Fragment, { children: selectedExpiryData.length > 0 && getAddToBasketModal == undefined && (_jsx(React.Suspense, Object.assign({ fallback: _jsx(Loader, {}) }, { children: _jsx(SelectedExpiry, { data: selectedExpiryData }) }))) }));
};
export default SelectedExpiryOc;
